export function FullScreenSpinner() {
  return (
    <div
      role="status"
      aria-label="Loading"
      className="flex min-h-screen items-center justify-center bg-slate-50"
    >
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-slate-300 border-t-primary" />
    </div>
  )
}
